import React from "react";
import StepShell from "./StepShell";
import copy from "../copy";

const NameStep = ({ data, handleChange, onNext, onBack }) => {
  const valid = data.nombre?.trim() && data.apellido?.trim();

  return (
    <StepShell title={copy.name.title} onBack={onBack}>
      <form
        className="rp-form"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) onNext();
        }}
      >
        <input
          className="rp-input"
          type="text"
          name="nombre"
          autoComplete="given-name"
          placeholder={copy.name.firstName}
          aria-label={copy.name.firstName}
          value={data.nombre}
          onChange={(e) => handleChange("nombre", e.target.value)}
        />
        <input
          className="rp-input"
          type="text"
          name="apellido"
          autoComplete="family-name"
          placeholder={copy.name.lastName}
          aria-label={copy.name.lastName}
          value={data.apellido}
          onChange={(e) => handleChange("apellido", e.target.value)}
        />
        <div className="rp-actions">
          <button type="submit" className="rp-btn" disabled={!valid}>
            {copy.next}
          </button>
        </div>
      </form>
    </StepShell>
  );
};

export default NameStep;
